import { Route } from 'react-router';
import { Page } from '@roc/feature-app-core';
import { UnderwritingInternal } from '../underwritingInternal';
import { DelinquencyInternal } from '../delinquencyInternal';
import { ClosingInternal } from '../closingInternal';
import { LoanSystemNotificationInternal } from '../loanSystemNotificationInternal';
import { LoanTabInternal } from '../loanTabInternal';
import { LoanProcess } from '@roc/feature-utils';
import { DrawsInternal } from '../drawsInternal';
import { PayoffsInternal } from '../payoffsInternal';
import { ExtensionsInternal } from '../extensionsInternal';
import { PricingTabInternal } from '../pricingTabInternal';
import { ManualQuoteTabInternal } from '../manualQuoteTabInternal';
import { ServicingInternal } from '../servicingInternal';

const LOANS_HOME_BASE_PATH = 'loans';
const LOAN_BASE_PATH = ':loanId';

export const getLoanDetailsRoutesConfig = (
  basePath: string,
  baseUrl: string
) => {
  return {
    loans: (loanId?: string) => ({
      path: `${basePath}/${LOANS_HOME_BASE_PATH}/${LOAN_BASE_PATH}`,
      url: `${baseUrl}/${LOANS_HOME_BASE_PATH}/${loanId}`,
      children: {
        closing: {
          path: `${basePath}/${LOANS_HOME_BASE_PATH}/${LOAN_BASE_PATH}/closing`,
          url: `${baseUrl}/${LOANS_HOME_BASE_PATH}/${loanId}/closing`,
          documentTitle: `${loanId} - Closing`,
        },
        underwriting: {
          path: `${basePath}/${LOANS_HOME_BASE_PATH}/${LOAN_BASE_PATH}/underwriting`,
          url: `${baseUrl}/${LOANS_HOME_BASE_PATH}/${loanId}/underwriting`,
          documentTitle: `${loanId} - Underwriting`,
        },
        draws: {
          path: `${basePath}/${LOANS_HOME_BASE_PATH}/${LOAN_BASE_PATH}/draws`,
          url: `${baseUrl}/${LOANS_HOME_BASE_PATH}/${loanId}/draws`,
          documentTitle: `${loanId} - draws`,
        },
        payoffs: {
          path: `${basePath}/${LOANS_HOME_BASE_PATH}/${LOAN_BASE_PATH}/payoffs`,
          url: `${baseUrl}/${LOANS_HOME_BASE_PATH}/${loanId}/payoffs`,
          documentTitle: `${loanId} - Payoffs`,
        },
        extensions: {
          path: `${basePath}/${LOANS_HOME_BASE_PATH}/${LOAN_BASE_PATH}/extensions`,
          url: `${baseUrl}/${LOANS_HOME_BASE_PATH}/${loanId}/extensions`,
          documentTitle: `${loanId} - Extensions`,
        },
        loanSystemNotificationConversation: {
          path: `${basePath}/${LOANS_HOME_BASE_PATH}/${LOAN_BASE_PATH}/loan-system-notifications`,
          url: `${basePath}/${LOANS_HOME_BASE_PATH}/${loanId}/loan-system-notifications`,
          documentTitle: `${loanId} - Loan System Notifications`,
        },
        pricing: {
          path: `${basePath}/${LOANS_HOME_BASE_PATH}/${LOAN_BASE_PATH}/pricing`,
          url: `${baseUrl}/${LOANS_HOME_BASE_PATH}/${loanId}/pricing`,
          documentTitle: `${loanId} - Pricing`,
        },
        manualQuote: {
          path: `${basePath}/${LOANS_HOME_BASE_PATH}/${LOAN_BASE_PATH}/manual-quote`,
          url: `${baseUrl}/${LOANS_HOME_BASE_PATH}/${loanId}/manual-quote`,
          documentTitle: `${loanId} - Manual Quote`,
        },
        servicing: {
          path: `${basePath}/${LOANS_HOME_BASE_PATH}/${LOAN_BASE_PATH}/servicing`,
          url: `${baseUrl}/${LOANS_HOME_BASE_PATH}/${loanId}/servicing`,
          documentTitle: `${loanId} - Servicing`,
        },
        delinquency: {
          path: `${basePath}/${LOANS_HOME_BASE_PATH}/${LOAN_BASE_PATH}/delinquency`,
          url: `${baseUrl}/${LOANS_HOME_BASE_PATH}/${loanId}/delinquency`,
          documentTitle: `${loanId} - Delinquency`,
        },
      },
    }),

  };
};

export const getLoanDetailsRoutes = (basePath: string, baseUrl: string) => {
  const config = getLoanDetailsRoutesConfig(basePath, baseUrl);
  return {
    underwriting: (
      <Route exact path={config.loans().children.underwriting.path}>
        <Page routeDefinition={config.loans().children.underwriting}>
          <UnderwritingInternal />
        </Page>
      </Route>
    ),
    delinquency: (
      <Route exact path={config.loans().children.delinquency.path}>
        <Page routeDefinition={config.loans().children.delinquency}>
          <DelinquencyInternal />
        </Page>
      </Route>
    ),

    draws: (
      <Route exact path={config.loans().children.draws.path}>
        <Page routeDefinition={config.loans().children.draws}>
          <DrawsInternal />
        </Page>
      </Route>
    ),
    closing: (
      <Route exact path={config.loans().children.closing.path}>
        <Page routeDefinition={config.loans().children.closing}>
          <LoanTabInternal loanProcess={LoanProcess.CLOSING} />
        </Page>
      </Route>
    ),
    payoffs: (
      <Route exact path={config.loans().children.payoffs.path}>
        <Page routeDefinition={config.loans().children.payoffs}>
          <PayoffsInternal />
        </Page>
      </Route>
    ),
    extensions: (
      <Route exact path={config.loans().children.extensions.path}>
        <Page routeDefinition={config.loans().children.extensions}>
          <ExtensionsInternal />
        </Page>
      </Route>
    ),
    loanSystemNotificationConversation: (
      <Route exact path={config.loans().children.loanSystemNotificationConversation.path}>
        <Page routeDefinition={config.loans().children.loanSystemNotificationConversation}>
          <LoanSystemNotificationInternal />
        </Page>
      </Route>
    ),
    pricing: (
      <Route exact path={config.loans().children.pricing.path}>
        <Page routeDefinition={config.loans().children.pricing}>
          <PricingTabInternal />
        </Page>
      </Route>
    ),
    manualQuote: (
      <Route exact path={config.loans().children.manualQuote.path}>
        <Page routeDefinition={config.loans().children.manualQuote}>
          <ManualQuoteTabInternal />
        </Page>
      </Route>
    ),
    servicing: (
      <Route exact path={config.loans().children.servicing.path}>
        <Page routeDefinition={config.loans().children.servicing}>
          <ServicingInternal />
        </Page>
      </Route>
    ),
  };
};
